import { Model } from '@vuex-orm/core'
import { LangedItem } from './common/commons'

export default class MealPlan extends Model {
  declare id: string
  declare name: LangedItem[]
  declare description: LangedItem[]
  declare code: string

  static entity = 'mealplans'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      description: this.attr(null),
      code: this.attr(null)
    }
  }

  get langedName() {
    const name = this.name
    return (name && name.length && name[0].value) || ''
  }
}
